export default __webpack_public_path__ + "static/media/slipper2.7b547b15.png";